import { Component, h } from 'preact'
import axios from 'axios'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../../modal'
import InputGroup from '../../ui-components/InputGroup'
import ButtonControl from '../../button-control'

type Props = {
  baseApiUrl: string,
  isOpen: boolean,
  onClose: () => void,
  onIdeaMergedSuccess: () => void
}

type State = {
  ideaId: string,
  topicUrl: string,
  acknowledgement: boolean,
  errors: {
    [error: string]: string
  }
}

class MergeIdeaModal extends Component<Props, State> {
  private form: HTMLFormElement | null = null
  constructor () {
    super()
    this.state = {
      ideaId: '',
      topicUrl: '',
      acknowledgement: false,
      errors: {
        topicUrl: '',
        acknowledgement: ''
      }
    }
  }

  validate = () => {
    let errors = {}
    const { topicUrl, acknowledgement } = this.state

    if (!topicUrl) {
      Object.assign(errors, { topicUrl: 'Please enter a topic URL' })
    }

    if (!acknowledgement) {
      Object.assign(errors, { acknowledgement: 'Please confirm that you understand the ramifications of this action' })
    }

    if (Object.keys(errors).length > 0) {
      this.setState({ errors })
      throw new Error()
    }
  }

  onMergeIdea = async (e: Event) => {
    e.preventDefault()

    try {
      this.validate()
      await axios.post(`${this.props.baseApiUrl}/mergeVotes`, {
        toIdeaId: this.state.ideaId
      })
      this.props.onIdeaMergedSuccess()
    } catch (e) { }
  }

  onUrlInput = (e: ChangeEvent<HTMLInputElement>) => {
    const topicUrl = e.target.value

    try {
      const url = new URL(topicUrl)
      const splittedPath = url.pathname.split('/')
      const isIdea = splittedPath[1] === 'idea'

      if (!isIdea) throw new Error('Please enter an idea URL')

      const splittedTitle = splittedPath[2].split('-')
      const ideaId = splittedTitle[splittedTitle.length - 1]

      this.setState(({ errors }) => ({
        ideaId,
        topicUrl: url.toString(),
        errors: { ...errors, ...{ topicUrl: '' } }
      }))
    } catch (e) {
      const error: Error = e
      const errorMessage = error instanceof TypeError ? 'Please enter a valid URL' : error.message
      this.setState(({ errors }) => ({
        ideaId: '',
        topicUrl: '',
        errors: { ...errors, ...{ topicUrl: errorMessage } }
      }))
    }
  }

  render ({ isOpen, onClose }: Props, { topicUrl, acknowledgement, errors }: State) {
    return <Modal isOpen={isOpen} size='medium'>
      <ModalHeader title='Merge idea' onClose={() => onClose()} />
      <ModalBody>
        <div class='merge-idea-modal'>
          <form ref={(form: HTMLFormElement) => this.form = form} onSubmit={this.onMergeIdea}>
          <InputGroup
            value={topicUrl}
            title='Merge current idea into'
            type='text'
            placeholder='Enter a topic URL'
            onChange={this.onUrlInput}
            error={errors.topicUrl || undefined}
          />
          <InputGroup
            inline
            title='By merging this idea, votes in the current idea will be transferred to the other idea. This cannot be undone.'
            type='checkbox'
            onChangeCheckbox={(e: ChangeEvent<HTMLInputElement>) => this.setState(({ errors }) => ({
              acknowledgement: e.target.checked,
              errors: { ...errors, ...{ acknowledgement: e.target.checked ? '' : 'Please confirm that you understand the ramifications of this action' } }
            }))}
            checked={acknowledgement}
            error={errors.acknowledgement || undefined}
          />
          </form>
        </div>
      </ModalBody>
      <ModalFooter>
        <ButtonControl title='Merge' variant='primary' onClick={() => this.form?.requestSubmit()} class='qa-merge-idea' />
        <ButtonControl title='Cancel' onClick={() => onClose()} />
      </ModalFooter>
    </Modal>
  }
}

export default MergeIdeaModal
